import React from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Button, Icon } from 'antd';
import LazyLoad from 'react-lazy-load';

const store = ['appCollectStore', 'commonStore']
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'app',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    }
  }
  onClick = () => {
    const { data } = this.props;
    window.open(`${window.server}/web#/app/appDetail/${data.sw_id}`, '_blank');
  }
  view = (e) => {
    const { data } = this.props;
    const { commonStore: { view } } = this.props;
    view(data);
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  collect = (e) => {
    const { appCollectStore: { getCollectList, setMobxState, moduleType, callCollect }, data } = this.props;
    Modal.confirm({
      title: '确定取消收藏吗？',
      onOk: () => {
        callCollect({ collect: data.tms_iscoll === '1' ? '0' : '1', s_ids: data.sw_id }).then(data => {
          setMobxState({ current: 1 });
          getCollectList({ current: 1, module: moduleType });
        });
      }
    });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  apply = (e, id) => {
    window.open(`${window.server}/web#/app?id=${this.props.location.query.id}&appId=${id}`, '_blank');
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  render() {
    const server = window.server;
    const { data, prefixCls } = this.props;
    return (
      <div className={`${prefixCls}-portal`} onClick={this.onClick}>
        <div className={`${prefixCls}-portal-con`}>
          <LazyLoad height='100%'>
            <img src={`${server}${data.s_docfile}`} className={`${prefixCls}-portal-con-img`} alt='' />
          </LazyLoad>
          <div className={`${prefixCls}-portal-con-mask`} />
          <div className={`${prefixCls}-portal-con-title`}>
            <h1>{data.s_name}</h1>
            <p>
              <Button type='primary'
                onClick={this.view}
              >
                预览
              </Button>
              <Button style={{ marginLeft: 30 }} onClick={(e) => this.apply(e, data.sw_id)}>申请</Button>
            </p>
          </div>
          <div className={`${prefixCls}-portal-con-collect`} onClick={this.collect}>
            {data.tms_iscoll === '1' ? (<Icon type="star" />) : (<Icon type="star" theme="filled" style={{ color: '#1e94ff' }} />) }
            <span>{data.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>
          </div>
        </div>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/collect/AppPortal.js